import { render, staticRenderFns } from "./GoalSettingEntrance.vue?vue&type=template&id=c47c015a&scoped=true&lang=pug&"
import script from "./GoalSettingEntrance.vue?vue&type=script&lang=ts&"
export * from "./GoalSettingEntrance.vue?vue&type=script&lang=ts&"
import style0 from "./GoalSettingEntrance.vue?vue&type=style&index=0&id=c47c015a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47c015a",
  null
  
)

export default component.exports